module.exports = __webpack_public_path__ + "static/media/Macys.5938a35e.svg";